import { render, staticRenderFns } from "./InfoTopRight.vue?vue&type=template&id=b6d42fba&scoped=true&"
import script from "./InfoTopRight.vue?vue&type=script&lang=js&"
export * from "./InfoTopRight.vue?vue&type=script&lang=js&"
import style0 from "./InfoTopRight.vue?vue&type=style&index=0&id=b6d42fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d42fba",
  null
  
)

export default component.exports